import { ArrowUpDown } from 'lucide-react';

import { Button } from './button';

interface SortColumnButtonProps extends React.PropsWithChildren {
  onSort: () => void;
}

export function SortColumnButton({ onSort, children }: SortColumnButtonProps) {
  return (
    <Button
      variant="ghost"
      onClick={onSort}
      className="text-body text-fx-neutral-600 hover:text-fx-neutral-900 !p-0 font-normal hover:bg-transparent"
    >
      {children}
      <ArrowUpDown className="!h-3 !w-3" />
    </Button>
  );
}
